"use strict";
/*
 * Copyright (c) 2018 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalObjectStatus = void 0;
var ExternalObjectStatus;
(function (ExternalObjectStatus) {
    ExternalObjectStatus["ACTIVE"] = "ACTIVE";
    ExternalObjectStatus["MARK_FOR_DELETED"] = "MARK_FOR_DELETED";
    ExternalObjectStatus["DELETED"] = "DELETED";
})(ExternalObjectStatus = exports.ExternalObjectStatus || (exports.ExternalObjectStatus = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXh0ZXJuYWwtb2JqZWN0LXN0YXR1cy5lbnVtLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbW1vbi9lbnVtcy9leHRlcm5hbC1vYmplY3Qtc3RhdHVzLmVudW0udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBOzs7Ozs7R0FNRzs7O0FBRUgsSUFBWSxvQkFJWDtBQUpELFdBQVksb0JBQW9CO0lBQzlCLHlDQUFpQixDQUFBO0lBQ2pCLDZEQUFxQyxDQUFBO0lBQ3JDLDJDQUFtQixDQUFBO0FBQ3JCLENBQUMsRUFKVyxvQkFBb0IsR0FBcEIsNEJBQW9CLEtBQXBCLDRCQUFvQixRQUkvQiJ9